module.exports = __webpack_public_path__ + "img/crizal-white.35f856ca.svg";